import { Action, Dispatch } from 'redux';
import { IAppState } from '../../../state/reducers';
import { setAllClipsSelected } from './clipList';

export enum ActionType {
  UpdateSelectAll = 'Buttons.UpdateSelectAll',
}

export interface IButtonsAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  selectAll: boolean,
}

const INITIAL_STATE: IState = {
  selectAll: false,
};

export default function reducer(state = INITIAL_STATE, action: IButtonsAction) {
  switch (action.type) {
    case ActionType.UpdateSelectAll:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export const updateSelectAll = (selectAll: boolean) => (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  setAllClipsSelected(selectAll)(dispatch, getState);
  dispatch({
    type: ActionType.UpdateSelectAll,
    payload: {
      selectAll,
    },
  });
};
